/**
 * @date  2016-05-08
 */
export default function jqueryScrollbar() {
    return {
        restrict: 'AC',
        scope: {
            jqueryScrollbarConfig: '=',
            onScroll: '&',
            onScrollTop: '&',
            commonScroll: '&',
        },
        link(scope, element) {
            // 左侧导航滚动条
            function setSlimScroll() {
                let height = 0
                const config = scope.jqueryScrollbarConfig
                if (!config) {
                    height = $(window).height() - 60
                } else {
                    height = config.height
                }
                const options = {
                    height: `${height}px`,
                }
                $(element).slimScroll(options)
                if (config && config.class) {
                    $(element).parent('.slimScrollDiv').addClass(config.class)
                }
            }
            setSlimScroll()
            $(window).on('resize', setSlimScroll)

            $(element).on('scroll', () => {
                scope.commonScroll && scope.commonScroll()
                if (scope.onScroll) {
                    const { scrollHeight } = $(element).context// 251
                    const { scrollTop } = $(element).context// 0-18
                    const { clientHeight } = $(element).context// 233
                    if ((scrollHeight - clientHeight) - 2 <= scrollTop) {
                        scope.onScroll()
                    }
                    if (scrollTop <= 0) {
                        scope.onScrollTop()
                    }
                }
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/jqueryScrollbar/jqueryScrollbarDirective.js